import React, { useState } from 'react';
import logo from '../assets/Logo_SALVIR.png';
import logo2 from '../assets/Logo_SALVIR_letras.png'
import { Link } from 'react-router-dom';
import './Navbar.css';
import { sendEvent } from "../utils/ga4";
import { sendMetaEvent } from "../utils/metaPixel";

function Navbar() {
  // Estado que se utiliza para responsive es el toggle
  const [isMenuOpen, ] = useState(false);
   
  return (
    <>
    <nav className="navbar">
      <Link to="/" className="navbar-logo">
        <img src={logo} alt="Salvir Logo" className="logo" />
        <img src={logo2} alt="Salvir Logo" className="logo2" />
      </Link>
      <ul className={`navbar-links ${isMenuOpen ? 'active' : ''}`}>
        <li><a href="/#features">Funcionalidades</a></li>
        <li><a href="/#pricing">Precios</a></li>
        <li><a href="#footer">Soporte</a></li>
      </ul>
      <div className="navbar-buttons">
      <Link to="/login" onClick={() =>
            sendEvent({
              category: "Home",
              action: "Click_Inicia_Sesión_navbar",
              label: "NavbarLogin",
            })}>
        <button className="navbar-button login">Inicia Sesión</button>
      </Link>
      <Link
          to="/registro"
          onClick={() => {
            sendEvent({
              category: "Home",
              action: "Click_Regístrate_navbar",
              label: "NavbarRegistro",
            });

            // Meta Pixel — Lead
            sendMetaEvent("Lead");
          }}
        >
        <button className="navbar-button">Crear cuenta</button>
      </Link>
      </div>
      
    </nav>
   
    </>
  );
}

export default Navbar;

